export default ({ data, type }) => {
  const { farmUserDuiwuCouponVO } = data || {}
  if (!farmUserDuiwuCouponVO) {
    return {}
  }


  return {
    title: '实物券',
    form: [
      {
        type: 'textGroup',
        labelCol: { span: 3 },
        wrapperCol: { span: 24 },
        value: [
          {
            name: '实物券名称',
            value: farmUserDuiwuCouponVO.duiwuCouponName,
            display: farmUserDuiwuCouponVO.duiwuCouponName
          },
          {
            name: '核销截止时间',
            value: farmUserDuiwuCouponVO.usedTime,
            display: farmUserDuiwuCouponVO.usedTime
          },
          {
            name: '关联景点',
            value: farmUserDuiwuCouponVO.ticketScenicName,
            display: farmUserDuiwuCouponVO.ticketScenicName,
          },
          {
            name: '核销状态',
            value: { 0: '未核销', 1: '已核销' }[farmUserDuiwuCouponVO.status],
            display: farmUserDuiwuCouponVO.status
          }          
        ].filter((e) => e.display),
      },
    ],
  }
}
